import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';

export class GridLayout implements particles.ParticleLayout {
	public get(
		count: number,
		position: geometry.Vector2,
		size: geometry.Size,
		config = null
	): Array<particles.ParticleLookupProps> {
		let points: Array<particles.ParticleLookupProps> = [];
		let relativeX: number = position.x;
		let relativeY: number = position.y;
		let colIndex: number = 0;
		let rowIndex: number = 0;
		let cols: number = config && config.cols ? config.cols : 40;
		let rows: number = Math.round(count / cols);
		let gridSpacingX: number = size.w / cols;
		let gridSpacingY: number = size.h / rows;

		for (let i = 0; i < count; i++) {
			relativeX = position.x + colIndex * gridSpacingX;
			relativeY = position.y + rowIndex * gridSpacingY;
			colIndex++;
			if (colIndex === cols) {
				colIndex = 0;
				rowIndex++;
			}

			let thisIndex = points.length;
			let upLineIndex = -1;
			let downLineIndex = -1;

			if (colIndex != 0) {
				downLineIndex = thisIndex + 1;
			}

			upLineIndex = thisIndex + cols;


			points.push({
				x: relativeX,
				y: relativeY,
				downLineIndex: downLineIndex,
				upLineIndex: upLineIndex
			});
		}

		return points;
	}
}
